import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { ScoreCriteriaType } from "../../schema/score.schema";
import { RowPreview } from "../../shell/RowPreview";
import { CellAssignment, PersonaView, SegmentView } from "../../shell/scoreConfigView";
import { ScoreIssue } from "../../shell/scoreIssues";

interface PersonaPreviewProps {
	persona: PersonaView;
	/** The segments the persona exists in, with the scoring it gets there. */
	rows: { segment: SegmentView; assignment: CellAssignment | null }[];
	criteria: ScoreCriteriaType[];
	issues: ScoreIssue[];
}

/** The hover card of a persona chip (PREC-4055): its segments and their lead scoring. */
export const PersonaPreview: FunctionComponent<PersonaPreviewProps> = ({
	persona,
	rows,
	criteria,
	issues,
}) => {
	const { t } = useTranslation();

	return (
		<RowPreview
			criteria={criteria}
			deactivatedNote={persona.active ? undefined : t("leadScoring.personas.deactivatedNote")}
			description={persona.description}
			emptyPairs={t("leadScoring.personas.noSegmentYet")}
			issues={issues}
			pairs={rows.map(({ segment, assignment }) => ({
				key: segment.key,
				label: segment.name,
				assignment,
			}))}
			pairsTitle={t("leadScoring.personas.segmentsAndScoring")}
			testId={`persona-preview-${persona.id}`}
			title={persona.name}
		/>
	);
};
